<template>
  <div class="public-class-maange-page">
    <el-card>
      <el-form :model="filter" inline size="small">
        <el-form-item label="公开课名称">
          <el-input
            v-model="filter.skuName"
            placeholder="请输入公开课名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="公开课类型">
          <el-select v-model="filter.type" placeholder="请选择公开课类型" clearable>
            <el-option label="云直播" :value="1" />
            <el-option label="录播课" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button type="primary" size="small" style="margin-bottom: 10px" @click="add">新建公开课</el-button>
      <el-table :data="classList" border>
        <el-table-column align="center" label="公开课名称" prop="name" min-width="160">
          <template v-slot="{ row }">
            {{ row.lesperiod.name }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="公开课类型" prop="type" min-width="100">
          <template v-slot="{ row }">
            <span v-if="row.lesperiod.type === 1">云直播</span>
            <span v-else-if="row.lesperiod.type === 2">录播课</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="开始时间" prop="beginDate" min-width="160">
          <template v-slot="{ row }">
            {{ row.lesperiod.beginDate || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="结束时间" prop="endDate" min-width="160">
          <template v-slot="{ row }">
            {{ row.lesperiod.endDate || "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="公开课状态" prop="publishFlag" min-width="100">
          <template v-slot="{ row }">
            <span v-if="row.publishFlag === 1">已下架</span>
            <span v-else-if="row.publishFlag === 2">已上架</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="推荐状态" prop="recommendFlag" min-width="80">
          <template v-slot="{ row }">
            <span v-if="row.recommendFlag === 1">推荐</span>
            <span v-else-if="row.recommendFlag === 2">不推荐</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="课时状态" prop="recommendFlag" min-width="100">
          <template v-slot="{ row: { lesperiod } }">
            <span v-if="lesperiod.shelfFlag === 1">已下架</span>
            <span v-else-if="lesperiod.shelfFlag === 2">已上架</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="教师" prop="priceUpgrade" min-width="100">
          <template v-slot="{ row }">
            {{ row.lesperiod.teacher && row.lesperiod.teacher.nickname }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="推荐时间" prop="recommendDate" min-width="160" />
        <el-table-column align="center" label="更新时间" prop="lastUpdateDate" min-width="160" />
        <el-table-column align="center" label="最后操作人" prop="lastUpdateName" min-width="100" />
        <el-table-column align="center" label="操作" min-width="120" fixed="right" >
          <template v-slot="{ row }">
            <el-button v-if="row.lesperiod.type !== 1" type="text" @click="addMaterials(row)">课程讲义</el-button>
            <el-button v-if="row.publishFlag === 2" type="text" @click="statusAmend(row)">下架</el-button>
            <el-button v-else type="text" @click="statusAmend(row)">上架</el-button>
            <br />
            <el-button type="text" @click="del(row.id)">删除</el-button>
            <el-button v-if="row.recommendFlag === 1" type="text" @click="recommendAmend(row)">取消推荐</el-button>
            <el-button v-else type="text" @click="recommendAmend(row)">推荐</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <!-- 新建公开课 -->
      <el-dialog :title="title" :visible.sync="dialogVisible" :before-close="handleClose" width="800px">
        <el-form :model="bingFilter" inline size="small">
          <el-form-item label="课时名称">
            <el-input v-model="bingFilter.name" placeholder="请输入课时名称" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="searchLesperiod">查询</el-button>
            <el-button type="" size="small" @click="resetLesperiod">重置</el-button>
          </el-form-item>
        </el-form>
        <el-card>
          <el-table :data="allLesperiod" style="width: 100%" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" width="55" :selectable="selectableFun" />
            <el-table-column label="课时名称" align="center" prop="name" />
            <el-table-column label="课时类型" align="center">
              <template v-slot="{ row }">
                <span v-if="row.type === 1">云直播</span>
                <span v-else-if="row.type === 2">录播课</span>
              </template>
            </el-table-column>
            <el-table-column label="开课时间" align="center" prop="beginDate" />
            <el-table-column label="结课时间" align="center" prop="endDate" />
          </el-table>
          <el-pagination
            style="margin-top: 10px; text-align: center"
            :current-page="bingFilter.page"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="bingFilter.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="bingFilterTotal"
            @size-change="handleBingFilterSizeChange"
            @current-change="handleBingFilterCurrentChange"
          />
        </el-card>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleClose">取 消</el-button>
          <el-button type="primary" size="small" @click="bingLesperiod">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 课程讲义设置 -->
      <el-dialog title="课程讲义设置" :visible.sync="dialogMaterialsVisible" :before-close="handleMaterialsClose" width="800px" >
        <el-form :model="lesperiodForm" :rules="rules" ref="lesperiodForm" label-width="80px" size="small">
          <el-form-item label="课程讲义" prop="courseHandouts">
            <QuillEditor v-model="lesperiodForm.courseHandouts" @getText="getText" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleMaterialsClose">取 消</el-button>
          <el-button type="primary" size="small" @click="submitMaterials">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  getPublicClassList,
  addPublicClass,
  updatePublicClass,
  delPublicClass,
} from "@/api/product/classManage";
import { getList } from "@/api/class/lesperiod";

import QuillEditor from "@/components/QuillEditor/index.vue";

export default {
  name: "PublicClasManage",

  components: { QuillEditor },
  data() {
    return {
      filter: {
        page: 1,
        limit: 10,
        skuName: null,
        type: null,
      },
      total: 0,
      classList: [],
      title: "",
      dialogVisible: false,
      bingFilter: {
        page: 1,
        limit: 10,
        name: "",
      },
      bingFilterTotal: 0,
      allLesperiod: [],
      lesperiodIds: [],
      dialogMaterialsVisible: false,
      editId: null,
      lesperiodForm: {
        courseHandouts: "",
      },
      rules: {
        courseHandouts: [
          { required: true, message: "请输入课程讲义", trigger: "blur" },
        ],
      },
      classAllList: [],
      text: null
    };
  },
  created() {
    this.getList();
    this.getAllList();
  },
  methods: {
    // 搜索
    search() {
      this.filter.page = 1;
      this.getList();
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach((key) => {
        this.filter[key] = null;
      });
      this.filter.page = 1;
      this.filter.limit = 10;
      this.getList();
    },
    // 列表
    async getAllList() {
      const res = await getPublicClassList({ page: 1, limit: -1 });
      if (res.code !== 0) return this.$message.error(res.message);
      let datas = res.data?.records || [];
      this.classAllList = datas.map((item) => {
        return item.lesperiod.id;
      });
    },
    // 列表
    async getList() {
      const res = await getPublicClassList(this.filter);
      if (res.code !== 0) return this.$message.error(res.message);
      this.classList = res.data.records;
      this.total = +res.data.total;
    },
    getText(text) {
      console.log(text)
      this.text = text
    },
    add() {
      this.title = "新建公开课";
      this.handleGetLesperiodList();
      this.dialogVisible = true;
    },
    // 绑定课程
    bingLesperiod() {
      if (this.lesperiodIds.length === 0) {
        this.$message.warning("请选择课时!");
        return;
      }
      const params = this.lesperiodIds.map((item) => ({ lesperiodId: item }));
      addPublicClass(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success("新增成功!");
          this.bingFilter = this.$options.data().bingFilter;
          this.allLesperiod = [];
          this.lesperiodIds = [];
          this.handleGetLesperiodList();
          this.search();
        }
      });
    },
    // 讲义
    addMaterials(row) {
      this.editId = row.id;
      this.lesperiodForm.courseHandouts = row.courseHandouts;
      this.dialogMaterialsVisible = true;
    },
    // 提交讲义
    submitMaterials() {
      this.$refs.lesperiodForm.validate(async (valid) => {
        if (valid) {
          if (!this.text) {
            console.log(this.text)
            return this.$message.warning('请输入讲义')
          }
          const params = {
            id: this.editId,
            ...this.lesperiodForm,
          };
          updatePublicClass(params).then(({ code }) => {
            if (code === 0) {
              this.$message.success("课程讲义设置成功!");
              this.handleMaterialsClose();
              this.getList();
            }
          });
        }
      });
    },
    // 修改状态
    statusAmend(row) {
      let operateStatus = "";
      let publishFlag = 1;
      switch (row.publishFlag) {
        case 1:
          operateStatus = "上架";
          publishFlag = 2;
          break;
        case 2:
          operateStatus = "下架";
          publishFlag = 1;
          break;
      }
      this.$confirm(`确认${operateStatus}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await updatePublicClass({ id: row.id, publishFlag });
        if (res.code !== 0) return this.$message.error(res.message);
        this.$message.success(`${operateStatus}成功!`);
        this.getList();
      });
    },
    del(id) {
      this.$confirm(`确认删除当前公开课?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await delPublicClass({ id });
        if (res.code !== 0) return this.$message.error(res.message);
        this.$message.success("删除成功!");
        this.getList();
      });
    },
    // 修改推荐状态
    recommendAmend(row) {
      let operateStatus = "";
      let recommendFlag = 1;
      switch (row.recommendFlag) {
        case 1:
          operateStatus = "取消推荐";
          recommendFlag = 2;
          break;
        case 2:
          operateStatus = "推荐";
          recommendFlag = 1;
          break;
      }
      this.$confirm(`确认${operateStatus}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await updatePublicClass({ id: row.id, recommendFlag });
        if (res.code !== 0) return this.$message.error(res.message);
        this.$message.success(`${operateStatus}成功!`);
        this.getList();
      });
    },
    // 弹窗
    searchLesperiod() {
      this.bingFilter.page = 1;
      this.handleGetLesperiodList();
    },
    resetLesperiod() {
      this.bingFilter = this.$options.data().bingFilter;
      this.handleGetLesperiodList();
    },
    // 获取课程列表
    handleGetLesperiodList() {
      const params = {
        skuId: 0,
        ...this.bingFilter
      }
      getList(params).then(({ code, data }) => {
        if (code === 0) {
          this.allLesperiod = data?.records || [];
          this.bingFilterTotal = parseInt(data.total, 10);
        }
      });
    },
    selectableFun(row) {
      if(row.isBind === 1){
        return false
      }
      return true
    },
    // 点击选择
    handleSelectionChange(val) {
      this.lesperiodIds = val.map((item) => item && item.id);
    },
    handleClose() {
      this.title = null;
      this.bingFilter = this.$options.data().bingFilter;
      this.allLesperiod = [];
      this.lesperiodIds = [];
      this.dialogVisible = false;
    },
    handleSizeChange(v) {
      this.filter.page = 1;
      this.filter.limit = v;
      this.getList();
    },
    handleCurrentChange(v) {
      this.filter.page = v;
      this.getList();
    },
    handleMaterialsClose() {
      this.editId = null;
      this.lesperiodForm.courseHandouts = "";
      this.dialogMaterialsVisible = false;
    },
    handleBingFilterSizeChange(v) {
      this.bingFilter.page = 1;
      this.bingFilter.limit = v;
      this.handleGetLesperiodList();
    },
    handleBingFilterCurrentChange(v) {
      this.bingFilter.page = v;
      this.handleGetLesperiodList();
    },
  },
};
</script>

<style>
</style>
